module.exports = __webpack_public_path__ + "static/amazon-seller-f7f13b75219d66d9b9a1f79125072b97.png";